const IconReport = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <defs><style>{'.cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}'}</style></defs>
    <g id="Layer_2" data-name="Layer 2"><g id="Icons"><path id="Path_489" data-name="Path 489" className="cls-1" d="M5,15V13m3,2V11m3,4V9m2,10H3a2,2,0,0,1-2-2V3A2,2,0,0,1,3,1H8.59a1,1,0,0,1,.7.29l5.42,5.42a1,1,0,0,1,.29.7V17A2,2,0,0,1,13,19Z" /></g></g>
  </svg>
);

export default IconReport;
